/** @format */

import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import LoadingBar from "react-redux-loading-bar";
import { useEffect, useState } from "react";
import AppRoutes from "../../AppRoutes";
import Footer from "../../components/Layout/footer";
import AppHeader from "../../components/Layout/header";
import WrapperContainer from "../../components/wrapper/WrapperContainer";
import { showHeaderHandler } from "../../helper/helperFunctions";
import { updateRoute } from "../../redux/reducers/authentication/authentication";
import { i18n } from "../../pages/private/languageSelector";
import { useSidebar } from "../../pages/private/analytics/useSidebarProvider";

const AppLayout = ({ user, currentRoute, statePath, updateRoute }) => {
  const location = useLocation();

  const [isAppWrapperContainer, setAppWrapperContainer] = useState(true);
  const [openNotification, setOpenNotification] = useState(false);

  useEffect(() => {
    const isAnalyticsPage = location.pathname === "/analytics";
    setAppWrapperContainer(!isAnalyticsPage);
    const body = document.getElementsByTagName("body")[0];
    if (window.location.pathname === "/analytics") {
      body.style.marginBottom = "0";
      body.style.backgroundColor = "#f2f3f8";
    } else {
      body.style.marginBottom = "";
      body.style.backgroundColor = "";
    }
  }, [location]);


  // --- Centralized breadcrumb updater ---
  useEffect(() => {
    const path = location.pathname;
    const breadcrumbMap = [
      { match: "/forms/form-management", step1: () => i18n("Form.FormsPanel"), step2: () => i18n("Form.Forms-List") },
      { match: "/forms/global-list", step1: () => i18n("Form.FormsPanel"), step2: () => i18n("Table.Responses") },
      { match: "/forms/archive", step1: () => i18n("Form.FormsPanel"), step2: () => i18n("Reports.Archive") },
      { match: "/forms/library", step1: () => i18n("Form.FormsPanel"), step2: () => i18n("global.Library") },
      { match: "/reports/my-reports", step1: () => i18n("Reports.ReportsPanel"), step2: () => i18n("Reports.Inspections") },
      { match: "/reports/other-reports", step1: () => i18n("Reports.ReportsPanel"), step2: () => i18n("Reports.OtherReports") },
      { match: "/reports/archive", step1: () => i18n("Reports.ReportsPanel"), step2: () => i18n("Reports.Archive") },
      { match: "/management/info", step1: () => i18n("Company.CompanySetting"), step2: () => i18n("Company.Info") },
      { match: "/management/users", step1: () => i18n("Company.CompanySetting"), step2: () => i18n("Company.Users") },
      { match: "/management/roles", step1: () => i18n("Company.CompanySetting"), step2: () => i18n("Company.Roles") },
      { match: "/management/sites", step1: () => i18n("Company.CompanySetting"), step2: () => i18n("Company.Sites") },
      { match: "/management/subscriptions", step1: () => i18n("Company.CompanySetting"), step2: () => i18n("Company.Subscriptions") },
      { match: "/analytics", step1: () => i18n("Analytics.Analytics"), step2: () => undefined },
      { match: "/company-user-profile", step1: () => i18n("global.Settings"), step2: () => undefined },
    ];

    const found = breadcrumbMap.find((item) => path.startsWith(item.match));

    if (found) {
      const newStep1 = found.step1();
      const newStep2 = found.step2 ? found.step2() : undefined;

      if (currentRoute?.step1 !== newStep1 || currentRoute?.step2 !== newStep2) {
        updateRoute({
          step1: newStep1,
          step2: newStep2,
          enableBack: currentRoute?.enableBack,
          formScrol: currentRoute?.formScrol,
        });
      }
    }
  }, [location.pathname, updateRoute, currentRoute?.step1, currentRoute?.step2]);

  const scrollToTopButton = document.getElementById("scrollTop");
  const scrollFunc = () => {
    if (!scrollToTopButton) return;
    let y = window.scrollY;

    if (y > 0) {
      scrollToTopButton.className = `btn-scroll-top ${window.showScroll ? "show" : "hide"
        }`;
    } else {
      scrollToTopButton.className = "btn-scroll-top hide";
    }
  };

  // Day 21.8 — rAF-throttle the scroll listener. The raw handler used to
  // run on every wheel tick (~60+/s on modern mice, 120+/s on trackpads),
  // doing a layout read + DOM write each time → jank. rAF coalesces to one
  // run per frame. `passive: true` lets the browser skip the preventDefault
  // check, which it never called anyway.
  useEffect(() => {
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        scrollFunc();
        ticking = false;
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => {
    const c = document.documentElement.scrollTop || document.body.scrollTop;

    if (c > 0) {
      window.requestAnimationFrame(scrollToTop);
      window.scrollTo(0, c - c / 10);
    }
  };

  scrollToTopButton.onclick = function (e) {
    scrollToTop();
  };
  const { collapsed, setCollapsed } = useSidebar();

  return (
    <>
      {/* {showHeaderHandler(currentRoute, user) === true && <HeaderBar />} */}
      <LoadingBar className="loading-bar" />
      <div className="flex pb-8" style={location?.pathname.includes("/forms/form-management/") ? { overflow: 'hidden' } : {}}>
        {showHeaderHandler(currentRoute, user) === true ? (
          <AppHeader
            collapsed={collapsed}
            setCollapsed={setCollapsed}
            openNotification={openNotification}
            setOpenNotification={setOpenNotification}
          />
        ) : null}

        {showHeaderHandler(currentRoute, user) === true ? (
          <WrapperContainer
            collapsed={collapsed}
            setCollapsed={setCollapsed}
            user={user}
            setOpenNotification={setOpenNotification}
            openNotification={openNotification}
          >
            <AppRoutes />{" "}
          </WrapperContainer>
        ) : (
          <AppRoutes />
        )}
      </div>
      {location.pathname.includes("/subscriptions") && <Footer />}
    </>
  );
};
const mapStateToProps = ({ authentication }) => ({
  user: authentication.user,
  currentRoute: authentication.currentRoute,
});
const mapDispatchToProps = { updateRoute };
export default connect(mapStateToProps, mapDispatchToProps)(AppLayout);
